export default __webpack_public_path__ + "static/media/JimBertram400.563f234e.jpg";